// Rutas relativas — el Axios baseURL ('/api') ya agrega el prefijo.
// El proxy de Vite convierte /api/<ruta> → /<ruta> en el backend.
// No usar prefijo 'api/' aquí: causaría /api/api/<ruta>.

function createRoute(path: string) {
  return {
    INDEX: path,
    STORE: path,
    UPDATE: path,
    SHOW: path,
    DELETE: path,
  };
}

export const Routes = {
  DATA_PROVIDER: {
    INDEX: 'dataProviders',
  },
  TRANSPORTADORES: createRoute('transportadores'),
  DOMICILIOS: createRoute('domicilios'),
  TERMINALES: createRoute('terminales'),
  CONTACTOS: createRoute('contactos'),
  DANIOS: createRoute('danios'),
  PARTES: createRoute('partes'),
  MODELOS: createRoute('modelos'),
  TIPO_EVENTOS: createRoute('eventos'),
  OPERACIONES: {
    INDEX: 'clients/policies',
  },
  COMPANIASGPS: {
    INDEX: 'companiesGPS',
    STORE: 'companiesGPS',
    UPDATE: 'companiesGPS',
    SHOW: 'companiesGPS',
    DELETE: 'companiesGPS',
    ALL: 'companiesGPS/all',
  },
  AGENTES: {
    INDEX: 'agents',
    STORE: 'agents',
    UPDATE: 'agents',
    SHOW: 'agents',
    DELETE: 'agents',
    RESTORE: 'agents/restore',
    ALL: 'agents/all',
  },
  CLIENTES: {
    INDEX: 'clients',
    STORE: 'clients',
    UPDATE: 'clients',
    SHOW: 'clients',
    DELETE: 'clients',
    ALL: 'clients',
  },
};
